import { call, put, take, takeLatest } from "redux-saga/effects";

import * as limits from "middleware/addLimitRequest";
import { types, actions as addLimitRequestActions } from "reducers/addLimitRequest";
import { actions as formActions } from "reducers/form";
import { actions as notificationActions } from "reducers/notification";
import * as config from "util/config";

const sagas = [takeLatest(types.SUBMIT_REQUEST, addLimitRequest), takeLatest(types.LOAD_PRE_LIMITS, loadPreLimitsSaga)];

export default sagas;

function* loadPreLimitsSaga() {
    yield put(addLimitRequestActions.setLoadingLimits(true));
    const response = yield call(limits.loadTemporaryLimitPre);
    if (response.type === "I" && response.data.code === "COR000I") {
        const { limitsByReason, environmentLimit } = response.data.data;
        yield put(addLimitRequestActions.setPreLimits(limitsByReason, environmentLimit));
    } else {
        yield put(addLimitRequestActions.limitsFailure(response.data?.message));
    }
}

function* addLimitRequest({ requestData }) {
    const { motiveValue, temporaryLimit, durationValue, currencyValue } = requestData;
    const request = {
        reason: motiveValue,
        temporaryLimit,
        duration: durationValue,
        currency: currencyValue,
    };
    const response = yield call(limits.addLimitRequest, request);
    if (response.type === "I" && response.data.code === "COR000I") {
        yield put(
            formActions.readTransaction({
                pathname: `/transaction/${response.data.idTransaction}`,
                newTransaction: true,
            }),
        );
        yield put({ type: types.SUBMIT_SUCCESS });
        yield take("READ_TRANSACTION_REQUEST");
    } else {
        const businessErrorKey = response.data.data && response.data.data.NO_FIELD;
        if (response.data.code === "COR020W" && businessErrorKey) {
            yield put({ type: types.SUBMIT_FAILURE, error: response.data.message });
            yield put({ type: types.SET_FETCHING, fetching: false });
            yield put(
                notificationActions.showNotification(config.get("frontend.temporarily.limit.daily"), "warning", [
                    "addLimitRequestConfirmation",
                ]),
            );
        } else {
            if (response.data.code !== "COR023I") {
                yield put(notificationActions.showNotification(response.data.message, "error", ["limitTicket"]));
            }
            yield put(
                formActions.readTransaction({
                    pathname: `/transaction/${response.data.idTransaction}`,
                    newTransaction: true,
                }),
            );
            yield put({ type: types.SUBMIT_FAILURE, error: response.data.message });
            yield take("READ_TRANSACTION_REQUEST");
        }
    }
}
